import { ApiType } from "@gymflow/common";
import { Membership } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { membershipQueryKeys } from "./membershipQueryKeys";

export function useMembership(
  {
    api,
    membershipId,
  }: {
    api: ApiType;
    membershipId?: number;
  },
  opts?: Omit<UseQueryOptions<Membership | null>, "queryKey">,
) {
  return useQuery({
    queryKey: membershipQueryKeys.details(membershipId),
    queryFn: async () => {
      return (await api.serviceApi.findById(membershipId!)).data;
    },
    enabled: !!membershipId,
    ...opts,
  });
}
